"use client";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PartnerSelect } from "@/components/shared/PartnerSelect";

export function PartnerField({
  partnerId,
  partnerName,
  onChange,
}: {
  readonly partnerId: string | null;
  readonly partnerName: string | null;
  readonly onChange: (id: string | null) => void;
}) {
  const { t } = useTranslation();
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      <div className="px-3 pb-2">
        <div className="text-xs text-muted-foreground mb-1.5">
          {t("ai.userInput.selectPartner", "Partenaire")}
        </div>
        <PartnerSelect
          value={partnerId}
          onChange={(id) => {
            onChange(id);
            if (id) setEditing(false);
          }}
          placeholder={t(
            "ai.userInput.searchPartner",
            "Rechercher un partenaire...",
          )}
          size="sm"
        />
      </div>
    );
  }

  return (
    <div className="px-3 pb-2">
      <div className="text-xs text-muted-foreground mb-1.5">
        {t("ai.userInput.selectPartner", "Partenaire")}
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium">
          {partnerName ?? partnerId ?? "—"}
        </span>
        <button
          type="button"
          onClick={() => setEditing(true)}
          className="text-xs text-primary hover:underline"
          data-testid="partner-change-button"
        >
          {t("ai.userInput.change", "Changer")}
        </button>
      </div>
    </div>
  );
}
